import { DataSecurityMonitorType } from './DataSecurityMonitorType';

import { ComplianceCategory, DataSensitivityLevelId } from '../salesforce';

export type RecursivePartial<T> = NonNullable<T> extends object ? {
	[P in keyof T]?: NonNullable<T[P]> extends (infer U)[] ?
		RecursivePartial<U>[] : NonNullable<T[P]> extends object ? RecursivePartial<T[P]> : T[P];
} : T;

export enum MonitoringWindowType {
	Hourly = 'Hourly',
	Daily = 'Daily',
	Weekly = 'Weekly',
	Monthly = 'Monthly'
}

export enum MonitoringSchedule {
	Immediately = 'Immediately'
}

export type DataSecurityMonitorNotificationSettings = {
	isMuted?: boolean;
	stakeholderIds?: number[];
	notificationSchedule?: MonitoringSchedule;
};

export type DataSecurityMonitorBase<T = Record<string, unknown>> = DataSecurityMonitorNotificationSettings & {
	monitorConfig: T & { monitorTypeId: DataSecurityMonitorType };
	name: string;
	id: number;
	applicationId?: number;
};

export type SetupAuditTrailRuleTypes = 'and' | 'or';

export type SetupAuditTrailConditionalLogicRule = {
	condition: 'classification' | 'section' | 'action';
	value: Array<string>;
};

export type NewObjectAndFieldMonitor = DataSecurityMonitorBase<{
	blockAppsWhenAccessChanges: boolean;
}>;

export type UptimeMonitor = DataSecurityMonitorBase<{
	enableOnWeekends: boolean;
	monitoringWindow: MonitoringWindowType;
}>;

export type SetupAuditTrailMonitor = DataSecurityMonitorBase<{
	ruleType: SetupAuditTrailRuleTypes;
	rules: Array<SetupAuditTrailConditionalLogicRule>;
}>;

export type ConfigurableFieldAccessMonitor = DataSecurityMonitorBase<{
	dataSensitivityLevels: Array<DataSensitivityLevelId>;
	complianceCategories: ComplianceCategory;
}>;

export type DataSecurityMonitor = DataSecurityMonitorBase | ConfigurableFieldAccessMonitor |
	UptimeMonitor | SetupAuditTrailMonitor | NewObjectAndFieldMonitor;

export type MonitorFormTypes = RecursivePartial<DataSecurityMonitor> & {
	applicationIds?: Array<number>;
	overrideCount?: number;
	templateId?: number;
};
